/* eslint-disable react-hooks/rules-of-hooks */
// import React, { createContext, useState, useContext, ReactNode } from 'react';

// interface LoadingContextType {
//   isLoading: boolean;
//   setLoading: (value: boolean) => void;
// }

// const LoadingContext = createContext<LoadingContextType | undefined>(undefined);

// export const LoadingProvider = ({ children }: { children: ReactNode }) => {
//   const [isLoading, setIsLoading] = useState(false);

//   const setLoading = (value: boolean) => {
//     setIsLoading(value);
//   };

//   return (
//     <LoadingContext.Provider value={{ isLoading, setLoading }}>
//       {children}
//     </LoadingContext.Provider>
//   );
// };

// export const useLoading = (): LoadingContextType => {
//   const context = useContext(LoadingContext);
//   if (!context) {
//     throw new Error('useLoading must be used within a LoadingProvider');
//   }
//   return context;
// };

import React from 'react';

const Load: React.FC = () => {  

  return (
    <>
    <div id="preloader"></div>;
    </>   
    
  );
};

export default Load